export default __webpack_public_path__ + "static/media/video-light.ae334b61.svg";